import React from 'react'
import Marquee from "react-fast-marquee";
import { fetchListing } from '../../services';
import { useSelector } from 'react-redux';
import { PerPageData } from '../../store/actions';
import { useDispatch } from 'react-redux';


const MarqueeSlider = () => {

    const dispatch = useDispatch();

    const { info } = useSelector((state) => state.user);
    const { PageSize } = useSelector((state) => state.common);

    const [marQuee, setMarQuee] = React.useState([])
    const [marQueeString, setMarQueeString] = React.useState("")

    const getMarQueeData = async () => {
        let data = await fetchListing("/MasterAnnouncement/GetByEffectiveDate");
        if (data?.status === 200) {
            const str = data?.data.filter((item) => item.isActive).map((text, index) => (
                <span key={index}>
                    {text?.name}
                    {index !== data?.data.length - 1 && <span className="marqueeSpan">&nbsp;|&nbsp;</span>}
                </span>
            ));

            setMarQueeString(str)
            setMarQuee(data?.data);
        }
    };

    React.useEffect(() => {
        if (info || PageSize) {
            dispatch(PerPageData(PageSize ? PageSize?.toString() : info?.pageSize?.toString()))
        }
    }, [info, PageSize])

    React.useEffect(() => {
        getMarQueeData()
    }, [])

    return (marQuee.length > 0 &&
        <div className="marquee">
            <Marquee
                pauseOnHover={true}
                gradientColor={"red"}
            >{marQueeString}</Marquee>

        </div>
    )
}

export default MarqueeSlider
